<template>
	<div>
		<navTitle>
			<div class="flex flex-align-center flex-jus-center">
				<div class="selectCenter flex flex-align-center flex-jus-center" @click="resourcesPopShow = true">
					<span>{{majorName ? majorName : '请选择'}}</span>
					<img src="@/static/images/icon-arrowRight2.png" alt="" />
				</div>
			</div>
		</navTitle>

		<router-link :to="{ name: 'resources_video' }">
			<div class="homtTitle flex flex-align-center">
				<div class="left">学习资源</div>
				<div class="more flex-1">更多</div>
				<img src="@/static/images/icon-arrowRight.png" class="arrow" />
			</div>
		</router-link>

		<div class="videoList flex flex-align-center">
			<div class="videoItem" v-for="item in videoList" :key="item.id">
				<videoItem size="big" :id="item.id" :cover="item.pic ? item.pic : item.video + '?vframe/jpg/offset/0'" type="1" :content="item.title" :videoSrc="item.video"></videoItem>
			</div>

			<div class="flexStation"></div>
		</div>

		<router-link :to="{ name: 'resources_office' }">
			<div class="homtTitle flex flex-align-center">
				<div class="left">推荐机构</div>
				<div class="more flex-1">更多</div>
				<img src="@/static/images/icon-arrowRight.png" class="arrow" />
			</div>
		</router-link>

		<div class="officeTag flex flex-align-center">
			<div @click="changeType(item.id)" v-for="item in typeList" :key="item.id" class="officeTag-tag" :class="{'officeTag-tagActive': category_id == item.id}">{{item.name}}</div>
			<div class="flexStation"></div>
		</div>
		<div class="officeList">
			<office v-for="item in organizationList" :info="item" type="2" :key="item.id"></office>
		</div>

		<router-link :to="{ name: 'resources_teachers' }">
			<div class="homtTitle flex flex-align-center">
				<div class="left">名师风采</div>
				<div class="more flex-1">更多</div>
				<img src="@/static/images/icon-arrowRight.png" class="arrow" />
			</div>
		</router-link>

		<div class="recommendList flex flex-wrap flex-align-center">
			<div @click="$router.push(`/home/teacher/detail?id=${item.id}`)" class="recommend flex flex-column flex-align-center" v-for="item in teacherList" :key="item.id" >
				<img :src="item.avatar" class="avatar">
				<div class="name">{{item.truename}}</div>
				<div class="des">福建省民族管弦乐 学会会员</div>
			</div>
		</div>


		<resourcesPop :majorId="majorId" :resourcesPopShow.sync="resourcesPopShow" @changeResourcesPop="changeResourcesPop"></resourcesPop>
	</div>
</template>

<script>
/* eslint-disable */
import videoItem from '@/views/components/videoItem.vue';
import office from '@/views/components/office.vue';
import resourcesPop from '@/views/components/resourcesPop.vue';

export default {
	components: {
		videoItem,
		office,
		resourcesPop
	},
	data() {
		return {
			resourcesPopShow: false,
			majorId: '',
			majorName: '',

			videoList: [],

			typeList: [],
			category_id: '',
			organizationList: [],

			teacherList: [],

			myExpertSwiperOptions: {
				autoplay: {
					delay: 3500 //1秒切换一次
				},
				paginationClickable: true,
				centeredSlides: true,
				slidesPerView: 2
			}
		};
	},
	created() {
		this.majorId = localStorage.getItem('majorId') || ''
		if (!this.majorId) {
			this.resourcesPopShow = true
		}
		this.majorName = localStorage.getItem('majorName') || ''
		this.getVideo()
		this.getCategoryType()
		this.getOrganization()
		this.getTeacher()
	},
	mounted() {
		this.$wx.ready(() => {
      this.$wx.updateAppMessageShareData({
        title: '福建省民族管弦乐学会',
        desc: '教学园地',
        link: location.href,
        imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
      })
      this.$wx.updateTimelineShareData({
        title: '福建省民族管弦乐学会',
        link: location.href,
        imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
      })
    });
	},
	methods: {
		// 学习资源
		getVideo() {
			this.$get('api/actile/getLearningResourceVideoList', {
				major_id: this.majorId,
				page: 1,
				pageSize: 4
			}).then(res => {
				this.videoList = res.data
			})
		},
		// 推荐机构分类
		getCategoryType() {
			this.$get('api/actile/getLearningResourceOrganizationCategory').then(res => {
				this.typeList = [{
					name: '全部',
					id: ''
				}, ...res.data]
			})
		},
		// 推荐机构
		getOrganization() {
			this.$get('api/actile/getLearningResourceOrganizationList', {
				category_id: this.category_id,
				major_id: this.majorId,
				lat: localStorage.getItem('latitude'),
				lng: localStorage.getItem('longitude'),
				page: 1,
				pageSize: 3
			}).then(res => {
				this.organizationList = res.data
			})
		},
		changeType(id) {
			this.category_id = id
			this.getOrganization()
		},
		// 教师风采
		getTeacher() {
			this.$get('api/user/getUserAuthenticationList', {
				major_id: this.majorId,
				page: 1,
				pageSize: 6
			}).then(res => {
				this.teacherList = res.data
			})
		},
		changeResourcesPop(data) {
			this.majorId = data.id
			this.majorName = data.name
			localStorage.setItem('majorId', this.majorId)
			localStorage.setItem('majorName', this.majorName)
			this.resourcesPopShow = false
			this.getVideo()
			this.getTeacher()
			this.getOrganization()
		}
	}
};
</script>

<style scoped lang="stylus">
.expertSwiper
	margin-top 30px
	width 100%
	height 364px !important
	margin-bottom 60px
	.expertSwiper-slide
		width 320px
		height 364px
		padding 28px 24px
		transition 0.2s linear
		img
			width 100%
			height 100%
			border-radius 10px
	.swiper-slide-active
		transform scale(1.2)
.selectCenter
	margin 0 auto
	min-width 160px
	height 64px
	border 2px solid #FFFFFF
	border-radius 38px
	font-size 28px
	color #FFFFFF
	padding 0 12px
	span
		word-break keep-all
	img
		margin-left 8px
		width 12px
		height 22px
.homtTitle
	padding 0 30px
	margin-top 40px
	width 100%
	height 70px
	background-image url('~@/static/images/index/titleBG.png')
	background-size 100px 70px
	background-position 30px 0
	background-repeat no-repeat
	.left
		margin-left 25px
		font-size 36px
		font-weight 800
		color #151925
	.more
		text-align right
		font-size 26px
		font-weight 500
		color #B1B1B1
	.arrow
		width 12px
		height 22px
		margin-left 12px
.videoList
	margin-top 28px
	padding-left 30px
	overflow-x auto
	.videoItem
		margin-right 24px
	.flexStation
		flex 0 0 30px
		height 1px
.officeTag
	padding 28px 0px 28px 30px
	overflow-x auto
	font-size 28px
	color #000000
	.officeTag-tagActive
		color #DE113C
		border 2px solid #DE113C !important
	.officeTag-tag
		min-width 164px
		padding 6px 20px
		text-align center
		height 52px
		border 2px solid #B1B1B1
		border-radius 26px
		margin-right 40px
	.flexStation
		flex 0 0 1px
		height 1px
.officeList
	padding 0 30px

.recommendList
	margin-top 32px
	padding 0 30px
	.recommend
		width 220px
		height 268px
		background-image url('~@/static/images/index/recommendBG.png')
		background-size 100% 100%
		background-position center
		padding 22px 14px
		text-align center
		margin-right 14px
		margin-bottom 14px
		&:nth-child(3n)
			margin-right 0
		.avatar
			width 100px
			height 100px
			border-radius 50%
		.name
			margin-top 10px
			font-size: 26px;
			font-weight: bold;
			color: #111111;
		.des
			margin-top 12px
			width 100%
			font-size: 22px;
			color: #7B6E5F;
</style>
